import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _CashDeskAccountCDP } from '../../../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    year?: any;
    idCashDeskAccount?: any;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const CDPCatalog = ({ idSelector, year, onChange, label, idCashDeskAccount }: Props) => {

    const CDPCatalog = useDataBean(_CashDeskAccountCDP)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [year, idCashDeskAccount])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        CDPCatalog.instance.getCashDeskAccountCDPCatalog(year, idCashDeskAccount).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "CDPs/RPs asociados "}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDCashDeskAccountCDP} >{item.DataBeanProperties.Mnemonic}-{item.DataBeanProperties.Consecutive}</option>
                        )
                    })
                }
            </select>
        </>
    )
}